// Icons used by the Opt-In page, inlined from the Figma vector exports
// (Carbon icon set, 5244:35). Sized by the caller via className.

export const WifiIcon = ({ className = "" }: { className?: string }) => (
  <svg
    aria-hidden
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-[2.875rem] h-[2.875rem] shrink-0 ${className}`}>
    <path
      d="M11.5 19.4062C12.2939 19.4062 12.9375 18.7626 12.9375 17.9687C12.9375 17.1748 12.2939 16.5312 11.5 16.5312C10.7061 16.5312 10.0625 17.1748 10.0625 17.9687C10.0625 18.7626 10.7061 19.4062 11.5 19.4062Z"
      fill="#98D8FF"
    />
    <path
      d="M7.52531 13.8239L8.54134 14.8396C9.33782 14.0811 10.3952 13.6574 11.4951 13.6562C12.595 13.655 13.6533 14.0762 14.4515 14.8329L15.4675 13.8169C14.4 12.7902 12.9761 12.2173 11.495 12.2187C10.0139 12.22 8.59096 12.7953 7.52531 13.8239Z"
      fill="#98D8FF"
    />
    <path
      d="M4.47709 10.7759L5.49312 11.7919C7.09733 10.2236 9.25127 9.34494 11.4947 9.3436C13.7381 9.34226 15.8931 10.2184 17.4992 11.7847L18.515 10.7689C16.6396 8.93268 14.1191 7.90493 11.4945 7.90627C8.86984 7.90762 6.35057 8.93781 4.47709 10.7759Z"
      fill="#98D8FF"
    />
    <path
      d="M21.5625 7.72018C18.8808 5.076 15.2661 3.59363 11.5 3.59363C7.73394 3.59363 4.11921 5.076 1.4375 7.72018V7.73635L2.44684 8.74569C4.85772 6.36694 8.10797 5.03264 11.4948 5.0313C14.8817 5.02995 18.133 6.36167 20.5458 8.7385L21.5625 7.72162V7.72018Z"
      fill="#98D8FF"
    />
  </svg>
);

export const DollarIcon = ({ className = "" }: { className?: string }) => (
  <svg
    aria-hidden
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-[2.875rem] h-[2.875rem] shrink-0 ${className}`}>
    <path
      d="M16.5313 14.7452C16.5313 11.4281 13.8144 11.0501 11.6315 10.7468C9.2524 10.4155 7.90625 10.1287 7.90625 8.08026C7.90625 6.36029 9.70823 5.75 11.2512 5.75C12.0202 5.72512 12.7841 5.88342 13.48 6.21182C14.1758 6.54022 14.7836 7.02933 15.2532 7.6388L16.3718 6.7362C15.8688 6.08947 15.243 5.54853 14.5302 5.14445C13.8175 4.74038 13.032 4.48114 12.2188 4.38164V2.15625H10.7813V4.32831C8.18283 4.48586 6.46875 5.95269 6.46875 8.08019C6.46875 11.4799 9.22157 11.8628 11.4335 12.1699C13.7713 12.4953 15.0938 12.7754 15.0938 14.7452C15.0938 16.9247 12.8422 17.25 11.5 17.25C9.03512 17.25 7.9938 16.5572 7.02801 15.3612L5.9095 16.2638C6.47931 17.0147 7.2163 17.6224 8.06196 18.0387C8.90763 18.455 9.83869 18.6685 10.7813 18.6622V20.8438H12.2188V18.6552C14.8965 18.4366 16.5313 16.9826 16.5313 14.7452Z"
      fill="#98D8FF"
    />
  </svg>
);

export const CheckmarkIcon = ({ className = "" }: { className?: string }) => (
  <svg
    aria-hidden
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-[2.5rem] h-[2.5rem] shrink-0 ${className}`}>
    <path
      d="M8.125 15L2.5 9.375L3.38375 8.49125L8.125 13.2319L16.6163 4.74125L17.5 5.625L8.125 15Z"
      fill="currentColor"
    />
  </svg>
);
